import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import CommunicateStep from "../../../../../../../shared/wizard/steps/communicateStep";
import { EDealRequestCommunicationType } from "../../../../../../../shared/wizard/steps/types";

interface IWishSwapStepBuy_3 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishSwapStepBuy_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishSwapStepBuy_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_2);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_4);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default WishSwapStepBuy_3;
